import { ProfileLoadable } from 'containers/Profile/ProfileLoadable';
import ROUTES, { routesNames } from './constants';

const createProfileLoadable = () =>
  [
    {
      path: ROUTES.PROFILE,
      name: routesNames.profile,
      component: ProfileLoadable,
      exact: true,
    },
  ];

export default createProfileLoadable;
